/**
 * Static config for the registry-driven dialog surface (`src/app/DialogHost.tsx`,
 * backed by `src/shared/stores/dialogStore.ts`).
 */

/**
 * How long to let the `Dialog` primitive's close animation play before the host
 * unmounts a hidden instance (two-phase close). Kept in sync with the
 * primitive's `duration-200` in `src/shared/components/ui/dialog.tsx`.
 */
export const DIALOG_EXIT_ANIMATION_MS = 200;
